
import React from "react";

const HeroBackground = () => {
  return (
    <div className="absolute -top-[10%] -right-[5%] w-1/2 h-[70%] opacity-20 blur-3xl rounded-full" style={{
      background: 'linear-gradient(180deg, rgba(242,76,39,0.8) 0%, rgba(242,76,39,0) 100%)'
    }}></div>
  );
};

export default HeroBackground;
